module.exports = __webpack_public_path__ + "img/OLd_Mosul.9d0839aa.png";